export var InjectFlags;
(function (InjectFlags) {
    InjectFlags["Default"] = "Default";
    InjectFlags["Self"] = "Self";
    InjectFlags["SkipSelf"] = "SkipSelf";
    InjectFlags["Optional"] = "Optional";
})(InjectFlags || (InjectFlags = {}));
/**
 * DI 容器抽象基类
 */
export class Injector {
}
